var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-layout-footer',{attrs:{"id":"footer"}},[_c('a',{attrs:{"href":"https://beian.miit.gov.cn/#/Integrated/index","target":"_blank"}},[_vm._v("浙ICP备14038176号-11")])])}
var staticRenderFns = []

export { render, staticRenderFns }